// Reconstructed from the supplied production build; original component names were unavailable.
import {
  ArrowLeftIcon,
  AwardIcon,
  BookOpenIcon,
  CodeIcon,
  GlobeIcon,
  HeartIcon,
  Helmet,
  LightbulbIcon,
  RocketIcon,
  StarIcon,
  TargetIcon,
  UsersIcon,
  ZapIcon,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
const MissionPage = () => {
  const a = useNavigate(),
    n = () => {
      a(-1);
    },
    i = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.5,
        },
      },
    },
    l = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    },
    c = [
      {
        id: 1,
        icon: BookOpenIcon,
        title: "Educational Excellence",
        description:
          "We believe in empowering students through high-quality projects and comprehensive learning resources that enhance understanding and practical skills.",
        color: "from-blue-500 to-cyan-500",
      },
      {
        id: 2,
        icon: UsersIcon,
        title: "Community Building",
        description:
          "Creating a supportive ecosystem where students, educators, and industry professionals collaborate to foster innovation and knowledge sharing.",
        color: "from-purple-500 to-pink-500",
      },
      {
        id: 3,
        icon: RocketIcon,
        title: "Innovation & Growth",
        description:
          "Continuously evolving our platform with cutting-edge technologies and methodologies to prepare students for the future of tech.",
        color: "from-green-500 to-emerald-500",
      },
      {
        id: 4,
        icon: GlobeIcon,
        title: "Global Accessibility",
        description:
          "Making quality educational resources accessible to students worldwide, breaking down barriers to learning and opportunity.",
        color: "from-orange-500 to-red-500",
      },
    ],
    u = [
      {
        icon: StarIcon,
        number: "10,000+",
        label: "Students Helped",
        color: "from-yellow-400 to-orange-500",
      },
      {
        icon: CodeIcon,
        number: "500+",
        label: "Projects Created",
        color: "from-blue-400 to-indigo-500",
      },
      {
        icon: AwardIcon,
        number: "95%",
        label: "Success Rate",
        color: "from-green-400 to-emerald-500",
      },
      {
        icon: ZapIcon,
        number: "24/7",
        label: "Support Available",
        color: "from-purple-400 to-pink-500",
      },
    ];
  return (
    <div className={"min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100"}>
      <Helmet>
        <title>{"Our Mission | CodeBruh"}</title>
        <meta
          name={"description"}
          content={
            "Learn about CodeBruh's mission to empower students through quality educational projects and foster innovation in learning."
          }
        />
      </Helmet>
      <section
        className={
          "bg-gradient-to-r from-slate-900 via-slate-800 to-indigo-900 relative overflow-hidden py-12 lg:py-16"
        }
      >
        <div className={"absolute inset-0 opacity-10"}>
          <div
            className={
              "absolute top-0 left-0 w-full h-full bg-gradient-to-br from-cyan-400/20 via-blue-500/20 to-purple-600/20"
            }
          />
          <div
            className={
              "absolute top-1/4 left-1/4 w-20 h-20 lg:w-32 lg:h-32 bg-white/5 rounded-full blur-2xl animate-pulse"
            }
          />
          <div
            className={
              "absolute bottom-1/4 right-1/4 w-16 h-16 lg:w-24 lg:h-24 bg-indigo-400/10 rounded-full blur-xl animate-pulse delay-1000"
            }
          />
        </div>
        <div className={"relative  mx-auto px-3 sm:px-4"}>
          <motion.div
            initial={{
              opacity: 0,
              x: -20,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.5,
            }}
            className={"mb-4 sm:mb-6 lg:mb-8"}
          >
            <button
              onClick={n}
              className={
                "group inline-flex items-center px-3 sm:px-4 lg:px-6 py-2 lg:py-3 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-lg lg:rounded-xl hover:bg-white/20 transition-all duration-300 text-xs sm:text-sm lg:text-base font-medium shadow-lg hover:shadow-xl"
              }
            >
              <ArrowLeftIcon
                className={
                  "w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 mr-1.5 sm:mr-2 group-hover:-translate-x-1 transition-transform duration-300"
                }
              />
              {"Go Back"}
            </button>
          </motion.div>
          <div className={"text-center"}>
            <motion.div
              initial={"hidden"}
              animate={"visible"}
              variants={i}
              className={"text-white"}
            >
              <div
                className={
                  "w-12 h-12 sm:w-14 sm:h-14 lg:w-20 lg:h-20 mx-auto mb-4 lg:mb-6 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl lg:rounded-2xl flex items-center justify-center shadow-2xl"
                }
              >
                <TargetIcon className={"w-6 h-6 sm:w-7 sm:h-7 lg:w-10 lg:h-10 text-white"} />
              </div>
              <h1
                className={
                  "text-xl sm:text-2xl lg:text-4xl font-bold mb-3 lg:mb-4 bg-gradient-to-r from-white to-slate-200 bg-clip-text text-transparent"
                }
              >
                {"Our Mission"}
              </h1>
              <p
                className={"text-sm sm:text-base lg:text-xl text-slate-300 mx-auto leading-relaxed"}
              >
                {
                  "Empowering the next generation of innovators through quality education and cutting-edge project solutions."
                }
              </p>
            </motion.div>
          </div>
        </div>
      </section>
      <main
        className={
          " mx-auto px-3 sm:px-4 py-6 sm:py-8 lg:py-12 -mt-6 sm:-mt-8 lg:-mt-12 relative z-10"
        }
      >
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={l}
          className={"space-y-6 sm:space-y-8 lg:space-y-12"}
        >
          <motion.div
            variants={i}
            className={
              "bg-white rounded-lg sm:rounded-xl lg:rounded-2xl shadow-xl border border-slate-100 overflow-hidden"
            }
          >
            <div className={"p-4 sm:p-6 lg:p-8 text-center"}>
              <div
                className={
                  "w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 mx-auto mb-4 sm:mb-6 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl lg:rounded-2xl flex items-center justify-center shadow-lg"
                }
              >
                <HeartIcon className={"w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 text-white"} />
              </div>
              <h2
                className={
                  "text-lg sm:text-xl lg:text-2xl font-bold text-slate-900 mb-3 sm:mb-4 lg:mb-6"
                }
              >
                {"What Drives Us Forward"}
              </h2>
              <p
                className={
                  "text-xs sm:text-sm lg:text-base text-slate-600 leading-relaxed text-justify  mx-auto mb-4 sm:mb-6"
                }
              >
                {
                  "At CodeBruh, we are passionate about bridging the gap between academic learning and practical application. Our mission is to provide students with comprehensive, high-quality project solutions that not only help them excel academically but also prepare them for real-world challenges in the technology industry."
                }
              </p>
              <p
                className={
                  "text-xs sm:text-sm lg:text-base text-slate-600 leading-relaxed text-justify  mx-auto"
                }
              >
                {
                  "We believe that every student deserves access to exceptional educational resources, regardless of their background or circumstances. Through our platform, we're building a community where learning, innovation, and success go hand in hand."
                }
              </p>
            </div>
            <div className={"h-0.5 sm:h-1 bg-gradient-to-r from-indigo-500 to-purple-500"} />
          </motion.div>
          <motion.div variants={i}>
            <div className={"text-center mb-6 sm:mb-8 lg:mb-12"}>
              <h2
                className={"text-lg sm:text-xl lg:text-2xl font-bold text-slate-900 mb-3 sm:mb-4"}
              >
                {"Our Core Values"}
              </h2>
              <p className={"text-xs sm:text-sm lg:text-base text-slate-600  mx-auto"}>
                {"The principles that guide everything we do at CodeBruh"}
              </p>
            </div>
            <div className={"grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8"}>
              {c.map((m, f) => (
                <motion.div
                  key={m.id}
                  variants={i}
                  className={
                    "bg-white rounded-lg sm:rounded-xl lg:rounded-2xl shadow-xl border border-slate-100 overflow-hidden group hover:shadow-2xl transition-all duration-300"
                  }
                >
                  <div className={"p-4 sm:p-6 lg:p-8"}>
                    <div className={"flex items-start gap-3 sm:gap-4"}>
                      <div
                        className={`w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-gradient-to-br ${m.color} rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}
                      >
                        <m.icon className={"w-5 h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 text-white"} />
                      </div>
                      <div className={"flex-1 min-w-0"}>
                        <h3
                          className={
                            "text-base sm:text-lg lg:text-xl font-bold text-slate-900 mb-2 sm:mb-3"
                          }
                        >
                          {m.title}
                        </h3>
                        <p
                          className={
                            "text-xs sm:text-sm lg:text-base text-slate-600 leading-relaxed text-justify"
                          }
                        >
                          {m.description}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className={`h-0.5 sm:h-1 bg-gradient-to-r ${m.color}`} />
                </motion.div>
              ))}
            </div>
          </motion.div>
          <motion.div variants={i}>
            <div className={"text-center mb-6 sm:mb-8 lg:mb-12"}>
              <h2
                className={"text-lg sm:text-xl lg:text-2xl font-bold text-slate-900 mb-3 sm:mb-4"}
              >
                {"Our Impact"}
              </h2>
              <p className={"text-xs sm:text-sm lg:text-base text-slate-600  mx-auto"}>
                {"Numbers that reflect our commitment to student success"}
              </p>
            </div>
            <div className={"grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6"}>
              {u.map((m, f) => (
                <motion.div
                  key={f}
                  variants={i}
                  className={
                    "bg-white rounded-lg sm:rounded-xl lg:rounded-2xl shadow-xl border border-slate-100 p-4 sm:p-6 lg:p-8 text-center group hover:shadow-2xl transition-all duration-300"
                  }
                >
                  <div
                    className={`w-10 h-10 sm:w-12 sm:h-12 lg:w-16 lg:h-16 mx-auto mb-3 sm:mb-4 bg-gradient-to-br ${m.color} rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}
                  >
                    <m.icon className={"w-5 h-5 sm:w-6 sm:h-6 lg:w-8 lg:h-8 text-white"} />
                  </div>
                  <div
                    className={
                      "text-lg sm:text-xl lg:text-2xl font-bold text-slate-900 mb-1 sm:mb-2"
                    }
                  >
                    {m.number}
                  </div>
                  <div className={"text-xs sm:text-sm text-slate-600 font-medium"}>{m.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          <motion.div
            variants={i}
            className={
              "bg-gradient-to-br from-indigo-50 to-purple-50 rounded-lg sm:rounded-xl lg:rounded-2xl border-2 border-indigo-200 p-4 sm:p-6 lg:p-8 text-center"
            }
          >
            <div
              className={
                "w-10 h-10 sm:w-12 sm:h-12 lg:w-16 lg:h-16 mx-auto mb-3 sm:mb-4 lg:mb-6 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg"
              }
            >
              <LightbulbIcon className={"w-5 h-5 sm:w-6 sm:h-6 lg:w-8 lg:h-8 text-white"} />
            </div>
            <h3 className={"text-base sm:text-lg lg:text-xl font-bold text-slate-900 mb-2 lg:mb-3"}>
              {"Our Vision for the Future"}
            </h3>
            <p
              className={
                "text-xs sm:text-sm lg:text-base text-slate-600 text-justify  mx-auto leading-relaxed"
              }
            >
              {
                "We envision a world where every student has the tools, resources, and support needed to turn their innovative ideas into reality. Through technology, community, and unwavering dedication to educational excellence, we're building the foundation for tomorrow's breakthrough innovations and industry leaders."
              }
            </p>
          </motion.div>
          <motion.div
            variants={i}
            className={
              "bg-gradient-to-r from-slate-900 to-indigo-900 rounded-lg sm:rounded-xl lg:rounded-2xl p-6 sm:p-8 lg:p-12 text-center relative overflow-hidden"
            }
          >
            <div className={"absolute inset-0 opacity-10"}>
              <div
                className={
                  "absolute top-1/4 left-1/4 w-16 h-16 lg:w-24 lg:h-24 bg-white/20 rounded-full blur-xl animate-pulse"
                }
              />
              <div
                className={
                  "absolute bottom-1/4 right-1/4 w-12 h-12 lg:w-20 lg:h-20 bg-cyan-400/20 rounded-full blur-lg animate-pulse delay-500"
                }
              />
            </div>
            <div className={"relative"}>
              <h3 className={"text-base sm:text-lg lg:text-xl font-bold text-white mb-3 sm:mb-4"}>
                {"Join Our Mission"}
              </h3>
              <p className={"text-xs sm:text-sm lg:text-base text-slate-300 mb-4 sm:mb-6  mx-auto"}>
                {
                  "Be part of a community that's shaping the future of education and technology. Start your journey with CodeBruh today."
                }
              </p>
              <button
                onClick={() => a("/products")}
                className={
                  "inline-flex items-center px-4 sm:px-6 lg:px-8 py-2 sm:py-3 lg:py-4 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold rounded-lg lg:rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-xs sm:text-sm lg:text-base"
                }
              >
                <RocketIcon className={"w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 mr-1.5 sm:mr-2"} />
                {"Explore Projects"}
              </button>
            </div>
          </motion.div>
        </motion.div>
      </main>
    </div>
  );
};
export { MissionPage };
